export default {
      id: "input__select-3-usage",
      viewBox: "0 0 10 5",
      url: __webpack_public_path__ + "img/icons.svg#input__select-3",
      toString: function () {
        return this.url;
      }
    }